/**
 * 环境监测store
 */

import axios from "../../utils/axios";

let state = {
  deviceCount: 0,
  deviceData: [],
  showData: []
};

let getters = {
  getSensorCount(state) {
    return state.deviceCount;
  },
  getSensorList(state) {
    return state.deviceData;
  },
};

let mutations = {
  setDeviceCount(state, payload) {
    state.deviceCount = payload.deviceCount;
  },
  setDeviceData(state, payload) {
    state.deviceData = payload.deviceData;
  },
  setShowData(state, payload) {
    state.showData = payload.showData;
  }
};

let actions = {
  sensorList(context, payload) { 
    return new Promise((resolve, reject) => {
      axios.get(`/environmental?room_id=${payload.roomId}`)
      .then(res => {
        if (res.status === 200) {
          resolve(this._vm.logIsShowMarkder?[...res.data.data,...res.data.data,...res.data.data]:res.data.data);
        }
      })
      .catch(error => {
        console.error(error);
        reject(error);
      })
    });
  },
};

export default {
  state,
  getters,
  mutations,
  actions
}